export const ACTIVITY_LIST_REQUEST = 'ACTIVITY_LIST_REQUEST'
export const ACTIVITY_LIST_SUCCESS = 'ACTIVITY_LIST_SUCCESS'
export const ACTIVITY_LIST_FAIL = 'ACTIVITY_LIST_FAIL'
export const ACTIVITY_LIST_RESET = 'ACTIVITY_LIST_RESET'

export const ACTIVITY_BY_PROJECT_LIST_REQUEST =
  'ACTIVITY_BY_PROJECT_LIST_REQUEST'
export const ACTIVITY_BY_PROJECT_LIST_SUCCESS =
  'ACTIVITY_BY_PROJECT_LIST_SUCCESS'
export const ACTIVITY_BY_PROJECT_LIST_FAIL = 'ACTIVITY_BY_PROJECT_LIST_FAIL'
export const ACTIVITY_BY_PROJECT_LIST_RESET = 'ACTIVITY_BY_PROJECT_LIST_RESET'

export const ACTIVITY_MESSAGE_CREATE_REQUEST = 'ACTIVITY_MESSAGE_CREATE_REQUEST'
export const ACTIVITY_MESSAGE_CREATE_SUCCESS = 'ACTIVITY_MESSAGE_CREATE_SUCCESS'
export const ACTIVITY_MESSAGE_CREATE_FAIL = 'ACTIVITY_MESSAGE_CREATE_FAIL'
export const ACTIVITY_MESSAGE_CREATE_RESET = 'ACTIVITY_MESSAGE_CREATE_RESET'

export const ACTIVITY_MARK_AS_READ_REQUEST = 'ACTIVITY_MARK_AS_READ_REQUEST'
export const ACTIVITY_MARK_AS_READ_SUCCESS = 'ACTIVITY_MARK_AS_READ_SUCCESS'
export const ACTIVITY_MARK_AS_READ_FAIL = 'ACTIVITY_MARK_AS_READ_FAIL'
export const ACTIVITY_MARK_AS_READ_RESET = 'ACTIVITY_MARK_AS_READ_RESET'

export const ACTIVITY_MARK_MESSAGES_AS_READ_REQUEST =
  'ACTIVITY_MARK_MESSAGES_AS_READ_REQUEST'
export const ACTIVITY_MARK_MESSAGES_AS_READ_SUCCESS =
  'ACTIVITY_MARK_MESSAGES_AS_READ_SUCCESS'
export const ACTIVITY_MARK_MESSAGES_AS_READ_FAIL =
  'ACTIVITY_MARK_MESSAGES_AS_READ_FAIL'
export const ACTIVITY_MARK_MESSAGES_AS_READ_RESET =
  'ACTIVITY_MARK_MESSAGES_AS_READ_RESET'
